"use client";
import AnimatedText from "@/components/common/AnimatedText";
import Link from "next/link";
import { useEffect, useState } from "react";
import { BsTelephoneForward } from "react-icons/bs";
import { GoLocation } from "react-icons/go";
import { SlClock } from "react-icons/sl";

export default function ContactInfo() {
  const [contact, setContact] = useState([]);
  const [about, setAbout] = useState({});
  const [socials, setSocials] = useState({});
  const [parkTiming, setParkTiming] = useState({});

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const [contactRes, webContentRes, parkTimingRes] = await Promise.all([
          fetch("/api/contactus"),
          fetch("/api/web-content"),
          fetch("/api/parktiming"),
        ]);

        if (!contactRes.ok || !webContentRes.ok || !parkTimingRes.ok) {
          throw new Error("API failed");
        }

        const contactData = await contactRes.json();
        const webContentData = await webContentRes.json();
        const parkTimingData = await parkTimingRes.json();

        setContact(contactData);
        setAbout(webContentData.about || {});
        setSocials(webContentData.socialLinks || {});
        setParkTiming(Array.isArray(parkTimingData) && parkTimingData.length > 0 ? parkTimingData[0] : {});
      } catch (error) {
        console.log(error);
      }
    };

    fetchFooterData();
  }, []);


  const contactData = contact[0];
  return (
    <section className="contact-info-section fix section-padding">
      <div className="container">
        <div className="section-title text-center">
          <h6 className="wow fadeInUp">
            <i className="fa-regular fa-arrow-left-long" />
            CONTACT US
            <i className="fa-regular fa-arrow-right-long" />
          </h6>
          <h2 className="splt-txt wow">
            <AnimatedText text={contactData?.title || "Arena Water Park"} />
          </h2>
        </div>
        <div className="row">
          <div
            className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 wow fadeInUp"
            data-wow-delay=".2s"
          >
            <div className="contact-box-items">
              <div className="icon">
                <GoLocation />
              </div>
              <div className="content">
                <h3>Our Address</h3>
                <p>{contactData?.parklocation}</p>
              </div>
            </div>
          </div>
          <div
            className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 wow fadeInUp"
            data-wow-delay=".4s"
          >
            <div className="contact-box-items">
              <div className="icon">
                <BsTelephoneForward />
              </div>
              <div className="content">
                <h3>Email & Phone</h3>
                <p>
                  Mobile :
                  <Link href={`tel:${contactData?.mobile}`}>
                    {contactData?.mobile}
                  </Link>
                  <br />
                  Email :
                  <Link href={`mailto:${contactData?.email}`}>
                    {contactData?.email}
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 wow fadeInUp"
            data-wow-delay=".6s"
          >
            <div className="contact-box-items">
              <div className="icon">
                <SlClock />
              </div>
              <div className="content">
                <h3>Hours of Operation</h3>
                <p>
                  {parkTiming?.openingTime && parkTiming?.closingTime
                    ? `${parkTiming.openingTime} - ${parkTiming.closingTime}`
                    : "Timing not available"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
